(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.subcategory = document.querySelector('.sticky .subcategory-navigation');
      this.announcement = document.querySelector('.announcement-bar-section');
      this.isTransparentEnabled = this.hasAttribute('data-transparent');

      this.transparentHeader = this.isTransparentEnabled ? this.header?.querySelector('.transparent-header') : null;

      if (this.isTransparentEnabled && this.header) {
        this.header.classList.add('section-header--transparent-enabled');
      }

      this.announcementHeight = this.announcement ? this.announcement.getBoundingClientRect().height : 0;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.desktopMQ = window.matchMedia('(min-width: 1025px)');

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.observeSubcategoryScroll();

      // 🔥 Desktop-only transparent header
      if (this.isTransparentEnabled) {
        this.observeTransparentHeader();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.onTransparentScroll) {
        window.removeEventListener('scroll', this.onTransparentScroll);
      }
    }

    /* =========================
     HEADER HEIGHT
  ========================== */
    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderTop() {
      if (!this.announcement) return;
      if (!this.header.classList.contains('scrolled-past-header')) {
        this.header.style.top = `${this.announcementHeight}px`;
      }
    }

    /* =========================
     INTERSECTION OBSERVER
  ========================== */
    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    /* =========================
     TRANSPARENT HEADER (DESKTOP ONLY)
  ========================== */
    handleTransparentHeader(e) {
      if (!this.isTransparentEnabled) return;
      if (!this.transparentHeader) return;

      if (e.matches) {
        this.observeTransparentHeader();
      } else {
        this.transparentHeader.classList.remove('transparent-header');
        this.header.style.top = '';
      }
    }

    observeTransparentHeader() {
      if (this.transparentObserverInitialized) return; // ⛔ prevent duplicates
      this.transparentObserverInitialized = true;
      if (!this.isTransparentEnabled) return;
      if (!this.transparentHeader) return;

      if (window.scrollY <= 5) {
        this.transparentHeader.classList.add('transparent-header');
        this.setHeaderTop();
      }

      this.onTransparentScroll = () => {
        if (document.body.classList.contains('search-open')) return;

        if (window.scrollY <= 5) {
          this.transparentHeader.classList.add('transparent-header');
          this.setHeaderTop();
        } else {
          this.transparentHeader.classList.remove('transparent-header');
          this.header.style.top = '';
        }
      };

      window.addEventListener('scroll', this.onTransparentScroll, { passive: true });

      if (this.announcement) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (!this.isTransparentEnabled) return;

            if (entry.isIntersecting && window.scrollY <= 5) {
              this.transparentHeader.classList.add('transparent-header');
              this.setHeaderTop();
            } else {
              this.transparentHeader.classList.remove('transparent-header');
              this.header.style.top = '';
            }
          },
          { threshold: 0 }
        );

        observer.observe(this.announcement);
      }
    }

    /* =========================
     SCROLL LOGIC
  ========================== */
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setHeaderTop();
    }

    /* =========================
     SUBCATEGORY STICKY FIX
  ========================== */
    observeSubcategoryScroll() {
      const subcat = this.subcategory;
      const header = this.header;
      if (!subcat || !header) return;

      const subcatTop = subcat.offsetTop;

      // placeholder to prevent layout jump
      const placeholder = document.createElement('div');
      placeholder.style.height = `${subcat.offsetHeight}px`;
      subcat.parentNode.insertBefore(placeholder, subcat);

      window.addEventListener(
        'scroll',
        () => {
          const scrollY = window.scrollY;

          const isSticky = header.classList.contains('shopify-section-header-sticky');
          const isHidden = header.classList.contains('shopify-section-header-hidden');

          // 🔥 ALWAYS GET CURRENT HEADER HEIGHT
          const currentHeaderHeight = header.offsetHeight;

          if (scrollY >= subcatTop - currentHeaderHeight) {
            subcat.classList.add('is-fixed');
          } else {
            subcat.classList.remove('is-fixed');
            subcat.style.top = '0';
          }

          if (subcat.classList.contains('is-fixed')) {
            if (!isSticky || isHidden) {
              subcat.style.top = `${currentHeaderHeight}px`;
            } else {
              subcat.style.top = `${currentHeaderHeight}px`;
            }
          }
        },
        { passive: true }
      );
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const searchArray = ['Rings', 'Earrings', 'Bracelets', 'Birthstone', 'Personalized'];

    const staticPlaceholder = 'Search for ';
    let dynamicPlaceholder = '';
    let searchPlaceholderIndex = 0;
    let offset = 0;
    const len = searchArray.length;
    let forwards = true;
    let skipCount = 0;
    const skipDelay = 15;
    const speed = 100;

    const inputs = document.querySelectorAll('.field .search__input');

    function type() {
      const currentText = searchArray[searchPlaceholderIndex];

      if (forwards) {
        if (offset >= currentText.length) {
          skipCount++;
          if (skipCount === skipDelay) {
            forwards = false;
            skipCount = 0;
          }
        }
      } else {
        if (offset === 0) {
          forwards = true;
          searchPlaceholderIndex++;
          if (searchPlaceholderIndex >= len) searchPlaceholderIndex = 0;
        }
      }

      dynamicPlaceholder = currentText.substring(0, offset);

      if (skipCount === 0) {
        if (forwards) {
          offset++;
        } else {
          offset--;
        }
      }

      inputs.forEach((el) => {
        el.setAttribute('placeholder', staticPlaceholder + dynamicPlaceholder);
      });

      requestAnimationFrame(() => {
        setTimeout(type, speed);
      });
    }

    // Start typing effect
    type();
  });

  } catch(e) { console.error(e); }
})();
})();
